/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Представление попапа заказа товаров с удаленного склада меньше минимума со страницы корзины
   */
  app.ItemsPopupView = app.View.extend({
    events: {
      'click .js-to-checkout': 'goToCheckout',
    },

    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#popup-items-template');
      this.initPopup();
    },

    /**
     * Инициализация попапа
     */
    initPopup: function () {
      this.popup = new als.Popup(this.$el);
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_CLOSE, (function () {
          this.beforePopupClose();
          app.fader.hide();
          if (app.isMobile) {
            $('body').removeClass('body_mobile_hidden');
          }
        }).bind(this)
      );
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        (function () {
          // Показываем по центру экрана
          var top = ($(window).height() - this.$el.outerHeight()) / 2 + window.pageYOffset,
            right = ($(window).width() - this.$el.outerWidth()) / 2;
          if (!app.isMobile) {
            this.$el.css({
              right: right,
              top: top
            });
          } else {
            $('body').addClass('body_mobile_hidden');
          }
        }).bind(this)
      );
    },

    /**
     * Действия перед закрытием попапа
     * (переопределяется в потомках)
     */
    beforePopupClose: function () {

    },

    /**
     * Загрузить товары с удаленного склада и показать прелодаер.
     * После получения товаров скрываем прелоадер и показываем попап.
     */
    fetchAndShow: function () {
      app.preloader.render();
      app.preloader.listenToOnce(this.collection, 'sync', app.preloader.remove);
      this.listenToOnce(this.collection, 'sync', this.render);
      this.collection.fetch();
    },

    render: function () {
      var templateData = {
          items: this.collection.toJSON(),
          currencySign: app.currentCurrency.sign,
          fractionNumber: app.helpers.NumberHelper.fractionNumber
        };

      this.$('.js-content-container').html(this.template(templateData));
      this.open();
    },

    /**
     * Рендерим прелоадер, скрываем попап и фейдер.
     * Не используем  popup.close(), чтобы не открывался попап о минимальной сумме заказа
     */
    beforeButtonAction: function () {
      app.preloader.render();
      this.$el.addClass('not_display');
      app.fader.hide();
    },

    /**
     * Отправляем на оформление заказа товаров с быстрой доставкой
     */
    goToCheckout: function () {
      this.beforeButtonAction();
      app.helpers.RedirectHelper.goToCheckout({is_fast_delivery: true});
    },

    /**
     * Открываем попап
     */
    open: function () {
      this.popup.open();
      app.fader.show();
    },
  });
})(jQuery);

}.call(window));